import { getHomepagelink } from '@tmh-website/services/link.service';
import { useContext, useEffect } from 'react';
import { LocalePrefix } from '../const';
import { GlobalContext } from '../contexts/global.context';

/**
 * Returns correct homepage link based on audience.
 * Also automatically sets the correct breadcrumb links
 */
export function useHomepageLink({ locale }: { locale: LocalePrefix }) {
  const { audience, homepageLinks } = useContext(GlobalContext);

  const newHomepageLink = getHomepagelink(homepageLinks!, locale, audience!);

  /**
   * Update any homepage links in Magento land (e.g. the product details page).
   */
  useEffect(() => {
    document.querySelectorAll('[data-breadcrumbs-home]').forEach(el => el.setAttribute('href', newHomepageLink));
  }, [newHomepageLink]);

  return newHomepageLink;
}
